import { render, staticRenderFns } from "./v-hero-custom.vue?vue&type=template&id=679f1f33&scoped=true&"
import script from "./v-hero-custom.vue?vue&type=script&lang=js&"
export * from "./v-hero-custom.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-custom.vue?vue&type=style&index=0&id=679f1f33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f1f33",
  null
  
)

export default component.exports